import { useQuery } from '@tanstack/react-query';
import axiosClient from '../clients/axiosClient';
import { appFeatureKeys } from './queryKeys';

export interface AppFeature {
  key: string;
  enabled: boolean;
  label: string;
  description?: string;
}

export function useAppFeatures(enabled = true) {
  return useQuery({
    queryKey: appFeatureKeys.web(),
    queryFn: async () => {
      const { data } = await axiosClient.get<{ features: AppFeature[] }>(
        '/api/app-features',
        { params: { platform: 'web' } },
      );
      return data.features ?? [];
    },
    enabled,
    // Fail-open: on error, keep whatever stale data was previously fetched.
    // TanStack Query preserves the last successful `data` on error by default.
    retry: 1,
  });
}
